import axios from 'axios';
import store from '../helpers/Store';
import { API_DOMAIN_NAME } from '../config/default';

const BASE_URL = process.env.REACT_APP_PORTAL_API;

const instance = axios.create({
    baseURL: BASE_URL,
    // withCredentials: true,
    headers: {
        'wapp-domain': API_DOMAIN_NAME,
    },
});

instance.interceptors.request.use(function (config) {
    const state = store.getState();
    config.params = config.params || {};
    if (state.session && state.session.access_token) {
        config.params['token'] = state.session.access_token;
    }
    if (state.session && state.session.currentVirtualAccount) {
        config.headers['amc-vaccount-id'] = state.session.currentVirtualAccount;
    }
    return config;
});

export const toHardLink = (endpoint) => {
    let url = `${BASE_URL}${endpoint}?`;
    const state = store.getState();
    if (state.session && state.session.access_token) {
        url += 'token=' + state.session.access_token;
    }
    if (state.session && state.session.currentVirtualAccount) {
        url += '&amc-vaccount-id=' + state.session.currentVirtualAccount;
    }
    return url;
};

export default instance;
